import { type UrlMatcher, type UrlSegment } from '@angular/router';

/** Matches only a populated settings outlet while leaving every segment for its child page route. */
export const settingsWindowMatcher: UrlMatcher = (segments: UrlSegment[]) =>
  segments.length > 0 ? { consumed: [] } : null;
